<template>
  <div>
    <div class="searchbox">
      <form action="#" method="get" class="form-inline form-float" @submit.prevent>
        <div class="form-group">
          <label for>活动名称：</label>
          <el-input v-model="search.name"></el-input>
        </div>
        <div class="form-group others">
          <span class="search_btn">
            <el-button
              @click="searchList"
              type="button"
              class="btn btn-primary"
              id="search_btn"
              :loading="loading"
              size="small"
            >
              查询
            </el-button>
          </span>
          <span class="add_btn">
            <button
              type="button"
              class="btn btn-default"
              id="addScope"
              @click="addOrEdit(null)"
            >
              添加
            </button>
          </span>
        </div>
      </form>
    </div>
    <div class="list-right">
      <el-table
        ref="table"
        border
        :data="tableListData"
        height="100%"
        :header-cell-style="tableHeaderStyle"
        :cell-style="styleObj"
        v-loading="loading"
      >
        <el-table-column
          show-overflow-tooltip
          label="活动名称"
          prop="name"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="开始时间"
          prop="startTime"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="结束时间"
          prop="endTime"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="创建用户"
          prop="crtName"
        ></el-table-column>
        <el-table-column show-overflow-tooltip label="操作" width="200px">
          <template slot-scope="scope">
            <!-- <button
              class="operate-button"
              type="button"
              @click="addOrEdit(scope.row.id)"
            >
              活动详情
            </button> -->
            <button class="edit" type="button" @click="addOrEdit(scope.row)">
              修改
            </button>
            <button class="delete" type="button" @click="del(scope.row.id)">
              删除
            </button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <page v-on:pagination="receivePaginationData" v-bind:pageObj="pageObj"></page>
    <component
      :is="currentComponent"
      :oneDetail="oneDetail"
      @func="emptyComponent"
    ></component>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

import {
  fetchRechargeConfigurationPage,
  updateOneRechargeConfiguration,
} from "@/api/url";

import Page from "../../commons/page.vue";

import RechargeAddOrEdit from "./components/rechargeAddOrEdit.vue";
import Complaint from "../../member/vehicleOwnerManagement/complaint.vue";

export default {
  data() {
    return {
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      oneDetail: null,
      currentComponent: null,
      search: {
        pageNumber: 1,
        pageSize: 10,
        name: null,
      },
      tableListData: [],
      pageObj:{},
      loading: false,
    };
  },
  computed: mapState({
    curIndex: (state) => state.page.curIndex,
    rowsCount: (state) => state.page.rowsCount,
  }),
  components: {
    Page,
    RechargeAddOrEdit,
    Complaint,
  },

  mounted: function () {
    this.tableList(this.search.pageNumber);
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },
    tableList: function (curPage) {
      this.loading = true;
      this.$get(fetchRechargeConfigurationPage(), {
        limit: this.search.pageSize,
        page: curPage,
        name: this.search.name ? this.search.name : null,
      }).then((res) => {
        const {
          status,
          data: { rows, offset, total },
        } = res;
        if (status !== 200) return;
        //翻页
        var pageObj = {
          curIndex: offset,
          rowsCount: total,
        };
        this.pageObj={...pageObj}
        // this.getPage(pageObj);
        this.tableListData = rows;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    searchList: function () {
      this.search.pageNumber = "1";
      this.tableList(this.search.pageNumber);
    },
    addOrEdit(oneDetail) {
      oneDetail ? (this.oneDetail = oneDetail) : (this.oneDetail = null);
      this.currentComponent = "recharge-add-or-edit";
    },
    emptyComponent(m) {
      this.currentComponent = null;
      switch (m) {
        case "add": {
          this.search.pageNumber = 1;
         
          this.tableList(this.search.pageNumber);
          break;
        }
        case "edit": {
          this.tableList(this.pageObj.curIndex);
          break;
        }
      }
    },
    del(id) {
      var _this = this;
      var index = _this.$layer.confirm(
        "您确定删除?",
        {
          btn: ["确定", "取消"],
          shade: true,
        },
        function () {
          _this.$layer.close(index);
          _this
            .$deleteRequest(`${updateOneRechargeConfiguration()}/${id}`)
            .then((data) => {
              if (data.status != 200)
                return _this.$layer.msg("删除失败", { time: 1 });
              _this.$notify({
                title: "成功",
                message: "删除成功",
                type: "success",
              });
              _this.tableList(_this.pageObj.curIndex);
            });
        }
      );
    },
  },
};
</script>
<style scoped>
.list {
  padding: 0 !important;
}
.table thead {
  background: #f9f9fb;
}
.searchbox .el-input {
  width: 180px !important;
}
</style>